import script from "./TravelItems.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelItems.vue?vue&type=script&setup=true&lang=js"

import "./TravelItems.vue?vue&type=style&index=0&id=bce7305c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bce7305c"]])

export default __exports__